var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntityList',{attrs:{"config":_vm.config,"columns":_vm.columns,"form-fields":_vm.formFields,"formatted-columns":_vm.formattedColumns,"single-edit":"","allow-duplicate":false,"authority":"Users_User_Group","enable-disable-toggle":""}})}
var staticRenderFns = []

export { render, staticRenderFns }